import React from 'react'

export const getAspectRatioPadding = (aspectRatio?: string): React.CSSProperties => {
  const [w, h] = aspectRatio?.split('/') ?? []
  return { paddingBottom: `${w && h && +h / +w ? (+h / +w) * 100 : 100}%` }
}
